export default {
  path: '/draft',
  components: {
    default: () =>
      import(
        /* webpackChunkName: "draft-layout" */ '@/modules/draft/DraftLayout.vue'
      )
  },
  children: [
    {
      path: 'wildrift/:draftSessionId/:teamNumber',
      name: 'DraftSessionWildRiftView',
      props: true,
      meta: {
        title: 'Wild Rift Ban/Pick'
      },
      component: () =>
        import(
          /* webpackChunkName: "draft-session-wild-rift-view" */ '@/modules/draft/views/DraftSessionWildRiftView'
        )
    },
    {
      path: 'lol/:draftSessionId/:teamNumber',
      name: 'DraftSessionLeagueView',
      props: true,
      meta: {
        title: 'League of Legends Ban/Pick'
      },
      component: () =>
        import(
          /* webpackChunkName: "draft-session-league-view" */ '@/modules/draft/views/DraftSessionLeagueView'
        )
    }
  ]
}
